export const quotesByEvent = (quotes) => {
  const out = {};
  quotes.forEach((q) => (q.event_ids || []).forEach((id) => { (out[id] = out[id] || []).push(q); }));
  return out;
};

export const quoteSnippet = (q) => (q.lines.length > 1
  ? q.lines.map((l) => `${l.speaker_name || "Unattributed"}: ${l.text}`).join(" / ")
  : `“${q.lines[0].text}” — ${q.lines[0].speaker_name || "Unattributed"}`);
